import RankVerifyPage from '@/modules/rank/rank-verify-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/verify/$slug')({
  component: RouteComponent,
});

function RouteComponent() {
  const { slug } = Route.useParams();
  return <RankVerifyPage slug={slug} />;
}
